<div class="mobilemenu" [ngClass]="{ 'mobilemenu--open': isOpen }">
  <div class="mobilemenu__body">
    <div class="row mb-2" style="border-bottom: 1px solid #fff">
      <div
        class="col-1 flex align-items-center"
        style="margin-left: 10px; height: 50px"
      >
        <i
          class="fa-regular fa-square-xmark fa-2x"
          style="cursor: pointer"
          (click)="menuStateService.close()"
        ></i>
      </div>
    </div>
    <div class="mobilemenu__content">
      <ul style="border-bottom: 1px solid #fff; padding-bottom: 7px">
        <div class="indicator__button" (click)="showStores()">
          <div
            style="
              height: 26px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 29px;
            "
          >
            <i class="fa-light fa-map-location-dot fa-xl"></i>
          </div>
          <div
            style="
              height: 26px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 20px;
            "
          >
            <span style="line-height: normal">{{ selectedStore.zone }}</span>
          </div>
        </div>
        @if(isSearchVehicleVisible){
        <div class="indicator__button" (click)="showVehicle()">
          <div
            style="
              height: 26px;
              display: flex;
              justify-content: center;
              align-items: center;

              width: 29px;
            "
          >
            <i class="fa-light fa-print-magnifying-glass fa-xl"></i>
          </div>
          <div
            style="
              height: 26px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 20px;
            "
          >
            <span style="line-height: normal">Buscador de filtros</span>
          </div>
        </div>
        } @if(orderTrackingVisible){
        <div
          class="indicator__button"
          (click)="validarCuenta(); menuStateService.close()"
        >
          <div
            style="
              height: 26px;
              display: flex;
              justify-content: center;
              align-items: center;

              width: 29px;
            "
          >
            <i class="fa-light fa-truck-fast fa-xl"></i>
          </div>
          <div
            style="
              height: 26px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 20px;
            "
          >
            <span style="line-height: normal">Seguimiento</span>
          </div>
        </div>
        }
      </ul>
      <ul>
        @for(item of menuCategoriesItems; track $index) {
        <li
          class="mb-3 flex justify-content-between"
          (click)="menuStateService.open(2, item)"
        >
          <div class="text-truncate">
            {{ item.name | titlecase }}
          </div>
          <div style="width: 20px">
            <i class="fa-solid fa-chevron-right"></i>
          </div>
        </li>
        }
        <li
          class="mb-3 flex justify-content-between"
          (click)="goToAllProducts()"
        >
          <div class="text-truncate">Ver todos los productos</div>
        </li>
      </ul>
      @if(menuItems.length){
      <ul style="border-top: 1px solid #fff; padding-top: 15px">
        @for(item of menuItems; track $index) {
        <li class="mb-3 flex justify-content-between">
          <div class="text-truncate" (click)="menuStateService.open(2, item)">
            {{ item.name | titlecase }}
          </div>
          <div style="width: 20px" (click)="menuStateService.open(2, item)">
            <i class="fa-solid fa-chevron-right"></i>
          </div>
        </li>
        }
      </ul>
      }
    </div>
  </div>
</div>

<app-nivel2 />
